export default async (eventName: string, payload?: Record<string, unknown>) => {
  try {
    await umami.track(eventName, payload)
  } catch (error) {
    console.error("Huginn:", error)
  }
}
